import type { RouteConfig } from 'vue-router';

export default [
  /**
   * 发票中心
   */
  {
    path: '/invoice',
    meta: {
      title: '发票中心',
    },
    component: () => import('@/views/invoice/index.vue'),
  },
  /**
   * 发票历史
   */
  {
    path: '/invoice/history',
    meta: {
      title: '发票历史',
    },
    component: () => import('@/views/invoice/history.vue'),
  },
] as RouteConfig[];
